export default __webpack_public_path__ + "static/digital-health-9fba0627c4812494fb5da05ea1800ad4.jpg";